/** Follow offset tuning (world pixels). */
export const FOLLOW_SLOT_BEHIND_PX = 56;
export const FOLLOW_SLOT_LATERAL_PX = 42;
export const FOLLOW_CATCH_UP_DISTANCE_PX = 72;
